import { render, staticRenderFns } from "./CTFNatas.vue?vue&type=template&id=37e69f84&scoped=true&"
import script from "./CTFNatas.vue?vue&type=script&lang=js&"
export * from "./CTFNatas.vue?vue&type=script&lang=js&"
import style0 from "./CTFNatas.vue?vue&type=style&index=0&id=37e69f84&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e69f84",
  null
  
)

export default component.exports